import "./DesktopApplicantListPageHeader.scss"

function DesktopApplicantListPageHeader(props) {
    return (
        <div className="desktopApplicantListPageHeader flex-column">
            <h2>Browse Current Applicants</h2>
            <span> Connecting Your Organization with Entry-Level Software Engineers Ready to Launch Their Tech Careers</span>
        </div>
    );
}

export default DesktopApplicantListPageHeader;